import { env } from "@app/resolveModule/env";
import UiLanguage, { browserLanguage, defaultLanguage } from "./UiLanguage";

export { browserLanguage, defaultLanguage };

export enum ContentLanguage {
	en = "en",
	ru = "ru",
	es = "es",
	zh = "zh",
	hi = "hi",
	fr = "fr",
	ar = "ar",
	pt = "pt",
	de = "de",
	ja = "ja",
	tr = "tr",
	ko = "ko",
	it = "it",
	pl = "pl",
	nl = "nl",
	cs = "cs",
	sv = "sv",
	uz = "uz",
	kk = "kk",
	fa = "fa",
}

export const overriddenLanguage = UiLanguage[env("DEFAULT_UI_LANGUAGE") as keyof typeof UiLanguage];

/** The interface language an `Accept-Language` header asks for: its first tag, by the primary subtag ("ru-RU" → ru). */
export const acceptLanguageToUiLanguage = (header?: string): UiLanguage | undefined => {
	const tag = header?.split(",")[0]?.split(";")[0]?.trim().split("-")[0]?.toLowerCase();
	return tag ? UiLanguage[tag as keyof typeof UiLanguage] : undefined;
};

export const resolveDefaultLanguage = (): UiLanguage => overriddenLanguage || browserLanguage() || defaultLanguage;

export const resolveLanguage = (current?: UiLanguage): UiLanguage => current || overriddenLanguage || defaultLanguage;

export default UiLanguage;
